module.exports = __webpack_public_path__ + "static/media/jumpseller-external.810e2a70.png";